import { writable, type Writable } from 'svelte/store';

function AIModelReady() {
	const { subscribe, set, update } = writable(
		JSON.parse(sessionStorage.getItem('ai_model_ready_devices')) || [],
	);

	return {
		set,
		subscribe,
		update: (id, stat) =>
			update((ai_model_list) => {
				return {
					...ai_model_list,
					[id]: { ...ai_model_list[id], [stat.key]: stat.value },
				};
			}),
		reset: () => set([]),
	};
}

export const ai_model_ready = AIModelReady();
ai_model_ready.subscribe((val) => sessionStorage.setItem('ai_model_ready_devices', JSON.stringify(val)));

export const ai_prompt_count: Writable<number> = writable<number>(0);

export const stackedMobileEvents = writable([]);
